import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "p-5"
};
const _hoisted_2 = { class: "columns is-variable is-5" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "column is-narrow" }, [
    /*#__PURE__*/ _createElementVNode("h1", { class: "subtitle mb-4" }, "Social Security"),
    /*#__PURE__*/ _createElementVNode("h3", null, "Requests for Social Security cards")
], -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1);
const _hoisted_5 = { class: "column is-narrow pt-3" };
const _hoisted_6 = { class: "tabs is-toggle is-small mb-3" };
const _hoisted_7 = { style: { "justify-content": "right" } };
const _hoisted_8 = { class: "field" };
const _hoisted_9 = { class: "control" };
const _hoisted_10 = { class: "table is-hoverable is-fullwidth" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("th", { style: { "min-width": "40%" } }, "Citizen Name", -1);
const _hoisted_12 = { key: 0 };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("th", null, "Created", -1);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("th", null, "Status", -1);
const _hoisted_15 = { key: 0 };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "Select a partner", -1);
const _hoisted_17 = [
    _hoisted_16
];
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { key: 2 };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("td", {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
}, "No results", -1);
const _hoisted_21 = [
    _hoisted_20
];
const _hoisted_22 = { key: 0 };
const _hoisted_23 = { style: { "vertical-align": "middle" } };
const _hoisted_24 = { class: "adaptiveLabel" };
const _hoisted_25 = { style: { "vertical-align": "middle" } };
const _hoisted_26 = { class: "adaptiveLabel" };
const _hoisted_27 = { key: 4 };
const _hoisted_28 = {
    colspan: "999",
    style: { "text-align": "center" },
    class: "pt-5"
};
import { useAsync } from "@/composables/useAsync";
import { useFilterForAsync } from "@/composables/useFilter";
import { isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import { formatDateShort, notifyNetworkError } from "@/core/utils";
import { requestStatusLabels } from "@/features/applications/model";
import { computed, ref, watch } from "vue";
import { apiSocialSecurity } from "./api";
import { onlineTerminalRequestStatuses, offlineTerminalRequestStatuses } from "./model";
import PartnerSelectField from "@/features/partners/PartnerSelectField.vue";
import { User, Core } from "@minicity/core";
// Fetch birth records from API
const LIMIT_SIZE = 150;
export default /*#__PURE__*/ _defineComponent({
    __name: 'SocialSecurityListingPanel',
    setup(__props) {
        const socialSecurityApplications = useAsync();
        if (sessionState.session) {
            switch (sessionState.session.user.role) {
                case User.Role.NETWORK_ADMIN:
                    socialSecurityApplications.fetch(apiSocialSecurity.getForNetwork()).catch(err => { notifyNetworkError("Failed to load applications", err); });
                    break;
                case User.Role.PARTNER_ADMIN:
                    socialSecurityApplications.fetch(apiSocialSecurity.getForPartner(sessionState.session.partnerId)).catch(err => { notifyNetworkError("Failed to load applications", err); });
                    break;
                case User.Role.PARTNER_USER:
                    socialSecurityApplications.fetch(apiSocialSecurity.getForCaseworker(sessionState.session.partnerId, sessionState.session.user.id)).catch(err => { notifyNetworkError("Failed to load applications", err); });
                    break;
                default:
                    console.error("Unexpected user type");
                    break;
            }
        }
        const partnerId = ref(null);
        watch(partnerId, () => {
            socialSecurityApplications.fetch(partnerId.value ? apiSocialSecurity.getForPartner(partnerId.value) : apiSocialSecurity.getForNetwork()).catch(err => { notifyNetworkError("Failed to load applications", err); });
        });
        // Search / category filtering
        const showAll = ref(false);
        const { searchQuery, filtered: filteredApplications, limited: limitedApplications } = useFilterForAsync(socialSecurityApplications, (appl) => `${appl.citizen.displayName} ${appl.id}`, LIMIT_SIZE);
        const activeCategory = ref("ACTIVE");
        const socialSecurityApplicationsToDisplay = computed(() => {
            return (showAll.value ? filteredApplications : limitedApplications).value.filter(socialSecurityApplication => {
                if (activeCategory.value == "ALL")
                    return true;
                // Which specific statuses do we consider to be "active"?
                const terminalStatuses = socialSecurityApplication.isOnlineApplication ? onlineTerminalRequestStatuses : offlineTerminalRequestStatuses;
                const isActive = !terminalStatuses.includes(socialSecurityApplication.status);
                if (activeCategory.value == "ACTIVE" && !isActive)
                    return false;
                if (activeCategory.value == "COMPLETE" && isActive)
                    return false;
                return true;
            });
        });
        return (_ctx, _cache) => {
            const _component_LoadingTableRow = _resolveComponent("LoadingTableRow");
            const _component_CitizenBadge = _resolveComponent("CitizenBadge");
            const _component_OpenTasksIndicator = _resolveComponent("OpenTasksIndicator");
            const _component_router_link = _resolveComponent("router-link");
            const _component_PartnerBadge = _resolveComponent("PartnerBadge");
            return (_unref(isFeatureEnabled)('SOCIAL_SECURITY'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        (_unref(isNetworkAdmin)())
                            ? (_openBlock(), _createBlock(PartnerSelectField, {
                                key: 0,
                                modelValue: partnerId.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((partnerId).value = $event)),
                                allowSelectAll: ""
                            }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("ul", _hoisted_7, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'ALL' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (activeCategory.value = 'ALL'))
                                        }, "All")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'ACTIVE' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[2] || (_cache[2] = ($event) => (activeCategory.value = 'ACTIVE'))
                                        }, "Active")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'COMPLETE' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[3] || (_cache[3] = ($event) => (activeCategory.value = 'COMPLETE'))
                                        }, "Complete")
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "input",
                                        type: "text",
                                        placeholder: "Search",
                                        autofocus: "",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(searchQuery) ? (searchQuery).value = $event : null))
                                    }, null, 512), [
                                        [_vModelText, _unref(searchQuery)]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("table", _hoisted_10, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _hoisted_11,
                                (_unref(isNetworkAdmin)())
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Partner"))
                                    : _createCommentVNode("", true),
                                _hoisted_13,
                                _hoisted_14
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_unref(isNetworkAdmin)() && partnerId.value == 'none')
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, _hoisted_17))
                                : (_unref(socialSecurityApplications).status == 'loading')
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                                        _createVNode(_component_LoadingTableRow)
                                    ]))
                                    : (socialSecurityApplicationsToDisplay.value.length == 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(socialSecurityApplicationsToDisplay.value, (socialSecurityApplication) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: socialSecurityApplication.id
                                            }, [
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/socialSecurity/${socialSecurityApplication.id}`,
                                                        class: "horizontal"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_CitizenBadge, {
                                                                citizen: socialSecurityApplication.citizen
                                                            }, null, 8, ["citizen"]),
                                                            _createVNode(_component_OpenTasksIndicator, {
                                                                entityType: _unref(Core).EntityType['Social Security'],
                                                                entityId: socialSecurityApplication.id
                                                            }, null, 8, ["entityType", "entityId"])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                (_unref(isNetworkAdmin)())
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                                                        _createVNode(_component_router_link, {
                                                            to: `/socialSecurity/${socialSecurityApplication.id}`
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_PartnerBadge, {
                                                                    partner: socialSecurityApplication.citizen.assignedCareProvider,
                                                                    noLink: ""
                                                                }, null, 8, ["partner"])
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["to"])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("td", _hoisted_23, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/socialSecurity/${socialSecurityApplication.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(formatDateShort)(socialSecurityApplication.createdAt)), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ]),
                                                _createElementVNode("td", _hoisted_25, [
                                                    _createVNode(_component_router_link, {
                                                        to: `/socialSecurity/${socialSecurityApplication.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(requestStatusLabels)[socialSecurityApplication.status]), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["to"])
                                                ])
                                            ]));
                                        }), 128)),
                            (_unref(socialSecurityApplications).status == 'ready' && _unref(filteredApplications).length > LIMIT_SIZE && !showAll.value)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_27, [
                                    _createElementVNode("td", _hoisted_28, [
                                        _createElementVNode("a", {
                                            onClick: _cache[5] || (_cache[5] = ($event) => (showAll.value = true))
                                        }, "Show All (" + _toDisplayString(_unref(filteredApplications).length - LIMIT_SIZE) + " more)", 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
